import { z } from 'zod';

const InterestAreaQuery = z.array(z.object({
    Id: z.number(),
    InterestAreaName: z.string(),
}));

export { InterestAreaQuery };